module.exports = __webpack_public_path__ + "img/adulto.90f6ca05.png";